function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#cacdd9;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-205 -321)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20,
  transform: "translate(205 321)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(205.461 322)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.539 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M18.03,13.21,15.518,10.7a1.671,1.671,0,0,0-2.781.628A1.709,1.709,0,0,1,10.764,12.4,7.746,7.746,0,0,1,6.1,7.738,1.626,1.626,0,0,1,7.175,5.764,1.671,1.671,0,0,0,7.8,2.983L5.291.471a1.792,1.792,0,0,0-2.422,0l-1.7,1.7c-1.7,1.794.179,6.549,4.4,10.766s8.971,6.19,10.766,4.4l1.7-1.7A1.792,1.792,0,0,0,18.03,13.21Z",
  transform: "translate(-0.539 0)"
}))));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.21ee8890.svg";
export { ForwardRef as ReactComponent };